<div #backgroundColorEl>
    <svg viewBox="0 0 48 48">
        <path d="M0 0h48v48h-48z" fill="none"/>
        <path d="M32 2h-24c-2.21 0-4 1.79-4 4v28h4v-28h24v-4zm6 8h-22c-2.21 0-4 1.79-4 4v28c0 2.21 1.79 4 4 4h22c2.21 0 4-1.79 4-4v-28c0-2.21-1.79-4-4-4zm0 32h-22v-28h22v28z"/>
    </svg>
</div>